function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 3,
  fill: "currentColor"
}), React.createElement("circle", {
  cx: 15,
  cy: 24,
  r: 3,
  fill: "currentColor"
}), React.createElement("circle", {
  cx: 28,
  cy: 16,
  r: 3,
  fill: "currentColor"
}), React.createElement("circle", {
  cx: 33,
  cy: 24,
  r: 3,
  fill: "currentColor"
}), React.createElement("circle", {
  cx: 20,
  cy: 32,
  r: 3,
  fill: "currentColor"
}), React.createElement("circle", {
  cx: 28,
  cy: 32,
  r: 3,
  fill: "currentColor"
}), React.createElement("circle", {
  cx: 20,
  cy: 16,
  r: 3,
  fill: "currentColor"
}));

var SvgRedness = function SvgRedness(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRedness, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/redness.4853d767.svg";
export { ForwardRef as ReactComponent };